"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = exports.actorsByCanisterId = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const AppAnonymous_1 = require("src/hello_assets/src/components/ui/anonymous/AppAnonymous");
const AppLoggedIn_1 = require("src/hello_assets/src/components/ui/loggedin/AppLoggedIn");
const PageLoaderComponent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/common/pageLoader/PageLoaderComponent"));
const MainRedirectComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/MainRedirectComponent");
const lodash_1 = __importDefault(require("lodash"));
const canisters_1 = require("../../util/canisters");
const NFIDAuthProvider_1 = require("geekfactory-ic-js-auth/lib/es5/auth/nfid/NFIDAuthProvider");
const geekfactory_ic_js_auth_1 = require("geekfactory-ic-js-auth");
const MixpanelAnalytics_1 = require("src/hello_assets/src/util/analytics/MixpanelAnalytics");
exports.actorsByCanisterId = {};
const clearActorsByCanisterId = () => {
    lodash_1.default.each(lodash_1.default.keys(exports.actorsByCanisterId), key => {
        delete exports.actorsByCanisterId[key];
    });
};
const AuthComponents = (props) => {
    const onLogout = (0, react_1.useCallback)(() => {
        MainRedirectComponent_1.LastProjectStorage.clear();
        clearActorsByCanisterId();
    }, []);
    const whitelist = lodash_1.default.cloneDeep(canisters_1.allKnownCanisterIds);
    return React.createElement(geekfactory_ic_js_auth_1.AuthSourceProvider, { storeNamespace: "ug-auth__" },
        React.createElement(geekfactory_ic_js_auth_1.InternetIdentityAuthProvider, { identityProviderURL: process.env.II_URL },
            React.createElement(NFIDAuthProvider_1.NFIDAuthProvider, { applicationName: "IDgeek", applicationLogo: `https://${canisters_1.Canisters.frontend}.raw.icp0.io/favicon-64.svg` },
                React.createElement(geekfactory_ic_js_auth_1.PlugAuthProvider, { whitelist: whitelist, autologinTimeout: 10000 },
                    React.createElement(geekfactory_ic_js_auth_1.StoicAuthProvider, null,
                        React.createElement(geekfactory_ic_js_auth_1.InfinityWalletAuthProvider, { whitelist: whitelist },
                            React.createElement(geekfactory_ic_js_auth_1.AuthProvider, { onLogout: onLogout }, props.children)))))));
};
const AppAuthSwitch = (0, react_1.memo)(() => {
    const authProviderContext = (0, geekfactory_ic_js_auth_1.useAuthProviderContext)();
    const isReady = authProviderContext.status.isReady;
    const isLoggedIn = authProviderContext.status.isLoggedIn;
    const source = authProviderContext.source;
    (0, react_1.useEffect)(() => {
        if (isReady) {
            MixpanelAnalytics_1.MixpanelAnalytics.Business.trackAppState({ source, loggedIn: isLoggedIn });
            if (isLoggedIn) {
                if (!!process.env.IS_TEST_SERVER) {
                    const currentPrincipal = authProviderContext.getCurrentPrincipal();
                    console.log("User is logged in: ", source, currentPrincipal === null || currentPrincipal === void 0 ? void 0 : currentPrincipal.toText(), currentPrincipal);
                }
            }
        }
    }, [isLoggedIn, isReady, source]);
    if (!isReady) {
        return React.createElement(PageLoaderComponent_1.default, null);
    }
    return authProviderContext.status.isLoggedIn ? React.createElement(AppLoggedIn_1.AppLoggedIn, null) : React.createElement(AppAnonymous_1.AppAnonymous, null);
});
const App = () => {
    (0, react_1.useEffect)(() => {
        if (!!process.env.IS_TEST_SERVER) {
            let label = process.env.NODE_ENV === "development" ? "** LOCAL **" : "** PROD DEBUG UI **";
            window.document.title = `${label} ${window.document.title}`;
        }
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement(AuthComponents, null,
            React.createElement(AppAuthSwitch, null)));
};
exports.App = App;
// class App extends React.Component<Props, any> {
//
//     render() {
//         const {context: {isAnonymous}} = this.props
//         // console.log("App: isAnonymous", isAnonymous);
//         if (isAnonymous) {
//             return <AppAnonymous/>
//         }
//         return <AppLoggedIn/>
//     }
// }
